// Components and constants intentionally exported for use by other modules.
// The Entitlements (ciem) page renders InventoryPage as its "Access grants"
// tab and routes to ACCESS_GRANTS_PATH; container-interface redirects the old
// /access-grants URL there. Keeping the path here makes access-grants the
// single source of truth for its own URL.
export { InventoryPage } from '../pages/inventory-page/inventory-page';

export const ACCESS_GRANTS_PATH = '/entitlements/access-grants';
